import { Component } from '@angular/core';
import {AuthService} from './auth/auth.service';
import {Router} from '@angular/router';

import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';


@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: ' <router-outlet></router-outlet>'
})
export class AppComponent {
  idleState = 'Not started.';
  timedOut = false;

  constructor( private idle:Idle, public authService: AuthService, private router: Router) {
    //sets the time out time in seconds and logs out the user after being idle for too long
    idle.setIdle(600);
    idle.setTimeout(20);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES)

    idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
       idle.onTimeout.subscribe(() => {
         this.idleState = 'Timed out!';
         this.timedOut = true;
         console.log('Timed out!');
         this.authService.logout();
       });
       idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
       idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');

    this.reset();

    this.authService.user.subscribe(
      (auth) => {
        if (auth == null) {
          console.log('Not Logged in.');
          this.router.navigate(['auth']);
        } else {
          this.reset();
          console.log('logged in ', auth);
          this.router.navigate(['']);
        }
      }
    );
  }


  reset(){
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts